import { render, staticRenderFns } from "./club-info.vue?vue&type=template&id=4c489851"
import script from "./club-info.vue?vue&type=script&lang=js"
export * from "./club-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c489851')) {
      api.createRecord('4c489851', component.options)
    } else {
      api.reload('4c489851', component.options)
    }
    module.hot.accept("./club-info.vue?vue&type=template&id=4c489851", function () {
      api.rerender('4c489851', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/club-info/club-info.vue"
export default component.exports